import React from "react"
import PropTypes from 'prop-types'

import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
// @ts-ignore
import PriorityMultiselectValueNotEmpty from "../components/multiselect/value-not-empty"
// @ts-ignore
import PriorityMultiselectPopoverOption from "../components/multiselect/popover-option"

export default class FieldPriority_AutomationTriggerForm extends React.Component<any> {

    static propTypes = {
        config          : PropTypes.object,

        // options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    onChangeFromValues    = (fromValues:any)    => this.props.onChangeCallback({fromValues})
    onChangeToValues      = (toValues:any)      => this.props.onChangeCallback({toValues})

    render() {

        const options = this.props.field.options

        return (
            <div className="flex-row-left-top">
                <div className="label">from</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       // options                          = {this.props.options}
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.config.fromValues}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {PriorityMultiselectValueNotEmpty}
                                       popoverOptionComponent           = {PriorityMultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeFromValues}/>

                <div className="label">to</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       // options                          = {this.props.options}
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.config.toValues}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {PriorityMultiselectValueNotEmpty}
                                       popoverOptionComponent           = {PriorityMultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeToValues}/>
            </div>
        )
    }
}
